import useSWR from 'swr';
import { useCallback } from 'react';
import { useShopifyCartContext } from '../onboarding/OnboardingFlowContainer/ShopifyCartProvider';

const SUPPLEMENTS = 'SPPL';
const TREATS = 'TRT';
const DENTAL_CHEWS = 'DC';

const getExtrasUrl = (cartId, petId) => {
  if (!cartId || !petId) return null;
  return `/api/v4/onboarding/${cartId}/pets/${petId}/extras/`;
};

// Shopify TODO: Mock data for testing Extras remove when moving to production

export const useShopifyExtras = petId => {
  const { cartId } = useShopifyCartContext();

  let {
    data: extras,
    isLoading: isExtrasLoading,
    isValidating: isExtrasValidating,
    error,
    mutate,
  } = useSWR(getExtrasUrl(cartId, petId));

  const extrasMap = {};
  const recommendedExtras = [];
  if (extras?.length) {
    extras.forEach(extra => {
      const productCode = extra.product_code;
      const isRecommended = extra.is_recommended;
      if (!extrasMap[productCode]) {
        extrasMap[productCode] = [];
      }
      if (isRecommended) {
        recommendedExtras.push(extra);
      }
      extrasMap[productCode].push(extra);
    });
  }

  const refreshExtras = useCallback(() => {
    mutate();
  }, [mutate]);

  return {
    treats: extrasMap[TREATS] || [],
    supplements: extrasMap[SUPPLEMENTS] || [],
    dentalChews: extrasMap[DENTAL_CHEWS] || [],
    recommendedExtras,
    error,
    isLoading: (cartId && petId && !extras && !error) || isExtrasLoading,
    isValidating: isExtrasValidating,
    refreshExtras,
  };
};
